import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
// material
import {
  Box,
  Card,
  Table,
  Stack,
  Button,
  IconButton,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Paper,
  TablePagination,
  Popover,
  ListItemIcon,
} from "@mui/material";
import Swal from "sweetalert2";
// Icono
import eyeFill from "@iconify/icons-eva/eye-outline";
// components
import Label from "../components/Label";
import Page from "../components/Page";
import Scrollbar from "../components/Scrollbar";
import Search from "../components/Search";
import ModalInput from "../components/ModalInput";
import Modal from "../components/Modal";
import Pdf from "../components/Pdf";
import Iconify from "../components/Iconify";
import { Api } from '../app-controller';
// ----------------------------------------------------------------------

const imgStyle = {
  float: 'left',
  padding: '10px 10px 10px',
  height: '200px',
  width: '300px'
};

const hiddenStyle = {
  display: 'none'
};

// ----------------------------------------------------------------------

const host = window.location.host.split(":")[0];

const tableHead = [
  { id: "titulo", label: "Titulo", alignRight: false },
  { id: "vista_previa", label: "Vista previa", alignRight: false },
  { id: "status", label: "Estado", alignRight: false },
  { id: "opciones", label: "Opciones", alignRight: true },
];

const title = "Nueva Convocatoria";

// ----------------------------------------------------------------------

function ShowConvocatoria({ ...props }) {
  const windowWidth = window.innerWidth;
  const { id, titulo, ext} = props.item;
  const [anchorEl, setAnchorEl] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setModalShow(true);
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    setModalShow(false);
  };

  return (
    <>
      <ListItemIcon
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onClick={(e) => handleClick(e)}
      >
        <Icon icon={eyeFill} width={24} height={24} />
      </ListItemIcon>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography sx={{ p: 1 }}>Ver</Typography>
      </Popover>

      <Modal
        key={id}
        title={titulo}
        information={
          ext !== 'pdf' ? (
            <img
              src={`${Api.url}getConvocatoriaPdf?id=${id}`}
              alt="Nombre de la imagen"
              style={windowWidth > 400 ? imgStyle : hiddenStyle}
            />
          ) : (
            <Pdf urlPdf={`${Api.url}getConvocatoriaPdf?id=${id}`} />
          )}
        
        isOpen={modalShow}
        handleClose={handleClose}
      />
    </>
  );
}
// ----------------------------------------------------------------------

export default class ConvocatoriasAdmin extends React.Component {
  constructor() {
    super();
    this.inicialState ={
      elementos:[
        {
          id: "titulo_M",
          label: "Titulo",
          input: "text",
          value: "",
          required: true,
          maxLength: 100,
        },
        {
          id: "pdf_M",
          label: "Archivo pdf",
          input: "archivo",
          value: null,
          ext: ".png, .jpg, .svg, .pdf",
          required: true,
        },
      ]
    };
    this.state = {
      convocatorias: [],
      elementos: this.inicialState.elementos,
      modalShow: false,
      notFound: false,
      searchArray: [],
      search: "",
      rowsPerPage: 5,
      page: 0,
      total: 0,
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
  }

  componentDidMount() {
    this.setConvocatoria();
    this.setCatalogos();
  }

  setCatalogos = () => {
    fetch(`${Api.url}getStatus`)
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          this.setSearch(data.statusArray);
        }
      });
  };

  setSearch = (statusArray) => {
    this.setState({
      searchArray: [
        {
          id: "descripcion",
          label: "Descripción",
          input: "text",
        },
        {
          id: "status",
          label: "Estado",
          input: "select",
          select: statusArray,
        },
      ],
    });
  };

  setConvocatoria = (query = "") => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.token}`,
      },
    };

    fetch(
      `${Api.url}getConvocatoriasAdmin?${query}`,
      requestOptions
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        throw new Error(response.status);
      })
      .then((data) => {
        if (data) {
          const auxNotFound = data.convocatorias.total === 0;

          this.setState({
            convocatorias: data.convocatorias.data,
            total: data.convocatorias.total,
            page: data.convocatorias.current_page - 1,
            notFound: auxNotFound,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: "No tiene acceso a ésta información",
          icon: "error",
          showCancelButton: false,
          cancelButtonColor: "green",
          confirmButtonText: "Continuar",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/admin/inicio";
          }
        });
      });
  };

  handleSearch = (search) => {
    let src = "";
    search.forEach((param) => {
      if (
        param.value !== undefined &&
        param.value !== null &&
        param.value !== ""
      )
        src += `&${param.nombre}=${param.value}`;
    });

    this.setState({ search: src });
    this.setConvocatoria(src);
  };

  handleChangeRowsPerPage = (event) => {
    const auxRowsPerPage = parseInt(event.target.value, 10);
    this.setState({ rowsPerPage: auxRowsPerPage, page: 0 });
    this.setConvocatoria(`rowsPerPage=${auxRowsPerPage}${this.state.search}`);
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
    this.setConvocatoria(
      `page=${newPage + 1}&rowsPerPage=${this.state.rowsPerPage}${
        this.state.search
      }`
    );
  };

  handleOpen = () => {
    this.setState({ modalShow: true });
  };

  handleClose = () => {
    this.setState({ modalShow: false, elementos: this.inicialState.elementos });
  };

  handleAddConvocatoria = (data) => {
    const postData = new FormData(); 
    let pasa = true;

    data.forEach((e) => {
      if (
        e.nombre === "pdf" &&
        e.value.ext !== "svg+xml" &&
        e.value.ext !== "png" &&
        e.value.ext !== "jpg" &&
        e.value.ext !== "jpeg" &&
        e.value.ext !== "svg" &&
        e.value.ext !== "pdf"
      ) {
        this.handleClose();
        Swal.fire({
          icon: "error",
          text: "Tipo de archivo no aceptado, intentelo nuevamente",
          allowOutsideClick: false,
        });
        pasa = false;
        return;
      }

      if (e.nombre === "titulo") {
        postData.append(e.nombre, JSON.stringify(e.value));
      } else {
        postData.append(e.nombre, e.value);
      }
    });

    if (pasa) {
      this.handleClose();
      Api.loading();

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${sessionStorage.token}`,
        },
        body: postData,
      };

      fetch(`${Api.url}createConvocatoria`, requestOptions)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          }
          throw new Error(response.status);
        })
        .then((data) => {
          Api.loading(false);
          
         Swal.fire({
            text: data.message,
            allowOutsideClick: false,
          });

          this.setConvocatoria(); // Actualizo tabla de links
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: "No tiene acceso a ésta información",
            icon: "error",
            showCancelButton: false,
            cancelButtonColor: "green",
            confirmButtonText: "Continuar",
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/admin/inicio";
            }
          });
        });
    }
  };

  handleStatusElemento = (id) => {
    Swal.fire({
      icon: "question",
      title: "¿Está seguro de realizar la acción?",
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      showCancelButton: false,
      confirmButtonText: `Continuar`,
      denyButtonText: `Regresar`,
      reverseButtons: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const requestOptions = {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.token}`,
          },
          body: JSON.stringify({ id }),
        };

        fetch(`${Api.url}deactivateConvocatoria`, requestOptions)
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            }
            throw new Error(response.status);
          })
          .then((data) => {
            Swal.fire({
              text: data.message,
              allowOutsideClick: false,
            });
            this.setConvocatoria(); // Actualizo tabla de convocatorias
          })
          .catch((error) => {
            Swal.fire({
              title: "Error",
              text: "No tiene acceso a ésta información",
              icon: "error",
              showCancelButton: false,
              cancelButtonColor: "green",
              confirmButtonText: "Continuar",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/admin/inicio";
              }
            });
          });
      }
    });
  };

  render() {
    return (
      <Page title="Convocatorias">
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <Typography variant="h4" gutterBottom>
              Convocatorias
            </Typography>
            <Box>
              <Button
                variant="contained"
                startIcon={<Icon icon={plusFill} />}
                onClick={() => this.handleOpen()}
              >
                Nueva convocatoria
              </Button>
              <ModalInput
                title={title}
                elementos={this.state.elementos}
                isOpen={this.state.modalShow}
                handleClose={this.handleClose}
                onHandleSubmit={this.handleAddConvocatoria}
              />
            </Box>
          </Stack>
          <Box sx={{ my: 2 }}>
            <Search
              onHandleSearch={this.handleSearch}
              elementos={this.state.searchArray}
            />
          </Box>
          <Card>
            <Scrollbar>
              <TableContainer sx={{ minWidth: "100%" }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      {tableHead.map((headCell, index) => (
                        <TableCell key={index} align="left">
                          {headCell.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.convocatorias.map((convocatoria, index) => (
                      <TableRow key={index}>
                        <TableCell align="left">
                          {convocatoria.titulo}
                        </TableCell>
                        <TableCell align="left">
                          <ShowConvocatoria item={convocatoria} />
                        </TableCell>
                        <TableCell align="left">
                          <Label
                            variant="ghost"
                            color={
                              (parseInt(convocatoria.status,10) === 0 && "error") ||
                              "success"
                            }
                          >
                            {parseInt(convocatoria.status,10) === 0 ? "Inactivo" : "Activo"}
                          </Label>
                        </TableCell>
                        <TableCell>
                          <IconButton
                            onClick={() =>
                              this.handleStatusElemento(convocatoria.id)
                            }
                          >
                            {parseInt(convocatoria.status,10) === 1 ? (
                              <Iconify icon="eva:close-fill" />
                            ) : (
                              <Iconify icon="eva:checkmark-outline" />
                            )}
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  {this.state.notFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper>
                            <Typography variant="body2" align="center">
                              No se encontraron resultados.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={this.state.total}
              rowsPerPage={this.state.rowsPerPage}
              page={this.state.page}
              onPageChange={this.handleChangePage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
            />
          </Card>
        </Container>
      </Page>
    );
  }
}
